import * as React from "react";
import FormikAutocompleteField from "../../formik/FormikAutocomplete";
import PropTypes from "prop-types";
import { HttpClientConfig } from "../../../utils/HttpClient";

export const UserStatusAutocomplete = (props) => {
  const lookupUrl = `${HttpClientConfig.baseURL}/UserStatus/Lookup`;
  const lookupByIdUrl = `${HttpClientConfig.baseURL}/UserStatus/LookupById`;

  const handleAddClick = (e) => {
    console.log(e);
  }

  return (
    <FormikAutocompleteField {...props} lookupUrl={lookupUrl} lookupByIdUrl={lookupByIdUrl} onAddButtonClick={handleAddClick} />
  );
};

UserStatusAutocomplete.propTypes = {
  fieldName: PropTypes.string,
  label: PropTypes.string,
  formik: PropTypes.any
}

export default UserStatusAutocomplete;
